<template>
  <label class="flex flex-col w-full" :for="identity">
    <span class="w-full font-semibold ml-2 text-gray-600" v-text="placeholder" v-if="withOutLabel" />

    <input
      class="w-full border placeholder-gray-400  text-gray-600 rounded-md py-2 px-2 shadow-sm focus:outline-none focus:border-primary border-border"
      :id="identity"
      :name="identity"
      :type="type"
      :placeholder="placeholder"
      :value="value"
      @input="handleChange($event.target.value)"
    />
  </label>
</template>
<script>
export default {
  name: "TextField",
  props: {
    withOutLabel: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    placeholder: {
      default: "",
    },
    identity: {
      defaul: "",
    },
    type: {
      default: "text",
    },
  },
  methods: {
    handleChange(_value) {
      this.$emit("input", _value);
    },
  },
};
</script>
